import React, { useState }  from 'react';
import PropTypes from "prop-types";
import axios from "axios";
import Modal from 'react-bootstrap/Modal';
import Button from '@mui/material/Button'
import CancelIcon from '@mui/icons-material/Cancel';
import Swal from 'sweetalert2'
import { Grid, TextField } from '@mui/material';
import { useFormik } from 'formik';
import { read, utils } from 'xlsx';
import { Link } from 'react-router-dom';

export const Add = ({user, show, setShow, getList, ...rest}) => {

    const formik = useFormik({
        initialValues: {},
        onSubmit: (values, { setSubmitting }) => {
            handleSubmit(values, setSubmitting);
        }
    });

    const handleClose = () => {
        formik.resetForm()
        setShow(false)
    }
    
    const handleSubmit = (values, setSubmitting)=>{
        const file = values.users_list;
        console.log(file, 'file')
        if(file){
            const reader = new FileReader();
            reader.onload = (event) => {
                const wb = read(event.target.result);
                const sheets = wb.SheetNames;
                const fileName = file.name;
                const fileExtension = fileName.split('.').pop();
                // console.log(fileExtension);
                // return false;
                if (fileExtension === 'xlsx' || fileExtension === 'xls') {
                    if (sheets.length) {
                        const rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);
                        axios.post(`api/subject/uploads`, {users: rows}).then(res => {
                            setSubmitting(false)
                            if(res.data.success){
                                setShow(false);
                                Swal.fire(res.data.message, '', 'success').then(result => {
                                    getList();  
                                })                
                            } 
                            else{
                                Swal.fire(res.data.message, '', 'error')
                            }
                        }).catch((error) => {
                            setSubmitting(false)                            
                            Swal.fire(error.response.data.message, '', 'error')
                        });
                    
                    }
                } else {
                    setSubmitting(false)
                    Swal.fire('Must be Upload excel file', '', 'error')
                }
            }
            reader.readAsArrayBuffer(file);
        }
        else{
            setSubmitting(false)
            Swal.fire('Please upload excel file', '', 'error')
        }
    }
    
    return (
        <Modal show={show} onHide={handleClose} dialogClassName="">
            <form autoComplete="off" onSubmit={formik.handleSubmit}>
                <Modal.Header>
                    <h5 className="modal-title fs-14 mb-0">Upload Excel</h5>
                    <CancelIcon style={{cursor: 'pointer'}} onClick={handleClose}/>
                </Modal.Header>
                <Modal.Body>
                    <Grid container spacing={6}>
                        <Grid  item xs={12} sm={6}>
                            <TextField fullWidth
                                ListboxProps={{
                                    sx: { fontSize: 13,
                                        fontFamily: 'Poppins' },
                                }}
                                sx={{
                                    '& .MuiAutocomplete-input, & .MuiInputLabel-root': {
                                        fontSize: 13,
                                        fontFamily: 'Poppins', // Add your desired font family
                                        fontWeight: '500', // Add your desired font weight
                                    },
                                }}
                                size='small'
                                type="file"
                                accept={".csv, .xlsx, .xls"}
                                name= 'users_list'
                                placeholder="Please select the product list"
                                className={formik.touched.users_list && formik.errors.users_list ?'is-invalid':''}
                                onChange={(e) => {
                                    formik.setFieldValue('users_list', e.currentTarget.files[0]);
                                    
                                    }}
                                onBlur={formik.handleBlur}
                            />
                            <Link to="/documents/SubjectSample.xlsx" target="_blank" className="fs-14" download>Download Sample File</Link>
                        </Grid>                        
                    </Grid>
                </Modal.Body>
                <Modal.Footer>
                    <Button size='small' type='reset' sx={{ marginRight: 3.5 }} variant='outlined' onClick={handleClose}>
                        Close
                    </Button>
                    <Button  size='small' type="submit" variant='contained' disabled={formik.isSubmitting}>
                       Upload
                    </Button>              
                </Modal.Footer>
            </form>
        </Modal>
    );
}

export default Add;
Add.propTypes = {
    type: PropTypes.string.isRequired,
    show: PropTypes.bool.isRequired,
    setShow: PropTypes.func.isRequired,
    handleClose: PropTypes.func.isRequired    
};